module.exports = __webpack_public_path__ + "static/media/card-elite.3eec8c38.png";